export const environment = {
  production: false,
  googleAnalyticsId: undefined,

  // DEV
  // siteUrl: 'https://thrwtydev.expertapps.com.sa',
  // appUrl: 'https://thrwtydevsystem.expertapps.com.sa',
  // apiUrl: 'https://thrwtydevapi.expertapps.com.sa/api',
  // socketUrl: 'https://thrwtydevsystem.expertapps.com.sa',

  // TESTmm
  // siteUrl: 'https://thrwtytest.expertapps.com.sa',
  // appUrl: 'https://thrwtytestsystem.expertapps.com.sa',
  // apiUrl: 'https://thrwtytestapi.expertapps.com.sa/api',

  /*******************************************/
  /*******************************************/

  // DEV STAGE
  // siteUrl: 'https://thrwtydevnew.expertapps.com.sa',
  // appUrl: 'https://thrwtydevnew.expertapps.com.sa',
  // apiUrl: 'https://thrwtydevapinew.expertapps.com.sa/api',
  // socketUrl: 'https://thrwtydevapinew.expertapps.com.sa',

  // STAGE
  siteUrl: 'https://thrwtystagenew.expertapps.com.sa',
  appUrl: 'https://thrwtystagenew.expertapps.com.sa',
  apiUrl: 'https://thrwtystageapinew.expertapps.com.sa/api',
  socketUrl: 'https://thrwtystagenew.expertapps.com.sa',

  // TEST
  // siteUrl: 'https://test.thrwty.com',
  // appUrl: 'https://systemtest.thrwty.com',
  // apiUrl: 'https://apitest.thrwty.com/api',
  // socketUrl: 'https://systemtest.thrwty.com',

  // PRODUCTION
  // siteUrl: 'https://thrwty.com',
  // appUrl: 'https://system.thrwty.com',
  // apiUrl: 'https://api.thrwty.com/api',
  // socketUrl: 'https://system.thrwty.com',
};
